// AddButton.tsx   ← feel free to rename as needed
import React from 'react';
import { Icons } from '../../icons';

interface Props {
  label: string; // button text
  responsive?: boolean;
  collapsed?: boolean;
  onClick?: () => void;
}

const InviteButton: React.FC<Props> = ({
  label,
  responsive = false,
  collapsed = false,
  onClick
}) => {

  return (
    <button
      onClick={onClick}
      type='button'
      className={`w-full flex items-center justify-center rounded-full
         bg-[#FF0050] text-white h-[56px]
         hover:bg-[#ff0051d7] transition-colors`}
    >
      <Icons.Plus className='h-6 w-6 lg:h-8 lg:w-8' fill='white' />

      {/* label only when sidebar open */}
      <span
        className={`${
          responsive && collapsed ? 'hidden lg:block' : ''
        } xl:ml-2 lg:text-sm xl:text-[18px]`}
      >
        {label}
      </span>
    </button>
  );
};

export default InviteButton;
